<div class="templates-container">
    <mat-card class="cardWithShadow">
        <mat-card-header>
            <div style="display: flex; justify-content: space-between; width: 100%;">
                <div>
                    <mat-card-title> {{ 'PRESCRIPTION_TEMPLATES' | translate }} ({{ dataSource?.data?.length || 0
                        }})</mat-card-title>
                    <span class="subtitle">{{ 'PRESCRIPTION_TEMPLATES_DESCRIPTION' | translate }}</span>
                </div>

                <div style="display: flex; gap: 15px; align-items: center;">
                    <mat-form-field appearance="outline" class="w-100 hide-hint">
                        <input matInput (keyup)="applyFilter($event)" placeholder="{{ 'SearchHere' | translate }}"
                            #input />
                    </mat-form-field>
                    <button class="m-l-15" mat-mini-fab color="primary" matTooltip="{{ 'Add' | translate}}"
                        (click)="showCreatePrescriptionTemplateModal()">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>

        </mat-card-header>
        <mat-card-content class="p-24">
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" class="w-100">

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">{{ 'NAME' | translate }}</th>
                        <td mat-cell *matCellDef="let element">
                            <div class="d-flex flex-column">
                                <p class="f-w-600 mat-subtitle f-s-16 m-0">
                                    {{ element.name }}
                                </p>
                                <p class="f-s-12 m-0"
                                    style="color: #999; word-break: break-word; white-space: normal; max-width: 300px; line-height: 1.4;">
                                    {{ element.description }}</p>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="type">
                        <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                            {{ 'TYPE' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element" class="f-s-14">
                            <span class="role-badge bg-primary">{{ element.type }}</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="createdAt">
                        <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                            {{ 'CREATED_AT' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element" class="f-s-14">
                            <span>{{ element.createdAt * 1000 | date:'dd/MM/yyyy' }}</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="updatedAt">
                        <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                            {{ 'UPDATED_AT' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element" class="f-s-14">
                            <span>{{ element.updatedAt * 1000 | date:'dd/MM/yyyy' }}</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="createdBy">
                        <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                            {{ 'CREATED_BY' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element" class="f-s-14">
                            <span>{{ element.createdBy }}</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef class="f-s-16 f-w-600">
                            {{ 'ACTIONS' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element" class="action-link">
                            <div style="display: flex;">
                                <a class="m-r-10 cursor-pointer icon" matTooltip="Edit"
                                    (click)="editPrescriptionTemplate(element.ID)"><i-tabler name="edit"
                                        class="icon-18"></i-tabler></a>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
                <div class="loading" *ngIf="isLoading">
                    <ngx-skeleton-loader [count]="10" [theme]="{ 'border-radius': '0', height: '50px' }"
                        [appearance]="'line'">
                    </ngx-skeleton-loader>
                </div>
                <mat-paginator [pageSizeOptions]="[25,50]" [length]="dataSource?.data?.length" [pageSize]="pageSize"
                    showFirstLastButtons></mat-paginator>
            </div>
        </mat-card-content>
    </mat-card>
</div>

<!-- Create prescription template modal -->
<p-dialog header="{{ 'CREATE_PRESCRIPTION_TEMPLATE' | translate }}" [(visible)]="createPrescriptionTemplateModalVisible"
    [modal]="true" (onHide)="onCreatePrescriptionTemplateModalClose()">

    <form [formGroup]="createPrescriptionTemplateForm" (ngSubmit)="createPrescriptionTemplate()">
        <div class="form-group">
            <label>{{ 'NAME' | translate }}</label>
            <input type="text" class="form-control" formControlName="name" id="name">
        </div>

        <div class="form-group">
            <label>{{ 'DESCRIPTION' | translate }}</label>
            <textarea class="form-control" formControlName="description" id="description" rows="4"
                style="resize: vertical; font-family: inherit;"></textarea>
        </div>

        <div class="form-group" *ngIf="user?.role === Roles.ROLE_DISTRIBUTOR">
            <div style=" display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
                <label style="margin: 0;">{{ 'METADATA' | translate }}</label>
                <button type="button" mat-icon-button (click)="addMetadataField('create')" matTooltip="Add metadata">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
            <div formArrayName="metadata">
                <div *ngFor="let item of getMetadataArray('create').controls; let i = index" [formGroupName]="i"
                    style="display: flex; gap: 8px; margin-bottom: 8px; align-items: flex-start;">
                    <input type="text" class="form-control" formControlName="key" placeholder="Key" style="flex: 1;">
                    <input type="text" class="form-control" formControlName="value" placeholder="Value"
                        style="flex: 1;">
                    <button type="button" mat-icon-button (click)="removeMetadataField('create', i)"
                        matTooltip="Remove">
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>
            </div>
        </div>

        <app-insoles-prescription [insolePrescription]="insolesPrescriptionForm"></app-insoles-prescription>

        <div class="create-button-container">
            <button type="submit" mat-raised-button color="primary"
                [disabled]="createPrescriptionTemplateForm.invalid">{{ 'CREATE' |
                translate }}</button>
        </div>
    </form>
</p-dialog>

<!-- Update prescription template modal -->
<p-dialog header="{{ 'UPDATE_PRESCRIPTION_TEMPLATE' | translate }}" [(visible)]="updatePrescriptionTemplateModalVisible"
    [modal]="true" (onHide)="onUpdatePrescriptionTemplateModalClose()">

    <form [formGroup]="updatePrescriptionTemplateForm" (ngSubmit)="updatePrescriptionTemplate()">
        <div class="form-group">
            <label>{{ 'NAME' | translate }}</label>
            <input type="text" class="form-control" formControlName="name" id="name">
        </div>

        <div class="form-group">
            <label>{{ 'DESCRIPTION' | translate }}</label>
            <textarea class="form-control" formControlName="description" id="description" rows="4"
                style="resize: vertical; font-family: inherit;"></textarea>
        </div>

        <div class="form-group">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
                <label style="margin: 0;">{{ 'METADATA' | translate }}</label>
                <button *ngIf="user?.role === Roles.ROLE_DISTRIBUTOR" type="button" mat-icon-button
                    (click)="addMetadataField('update')" matTooltip="Add metadata">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
            <div formArrayName="metadata">
                <div *ngFor="let item of getMetadataArray('update').controls; let i = index" [formGroupName]="i"
                    style="display: flex; gap: 8px; margin-bottom: 8px; align-items: flex-start;"
                    [style.opacity]="user?.role !== Roles.ROLE_DISTRIBUTOR ? 0.7 : 1">
                    <input type="text" class="form-control" formControlName="key" placeholder="Key" style="flex: 1;"
                        [readonly]="user?.role !== Roles.ROLE_DISTRIBUTOR">
                    <input type="text" class="form-control" formControlName="value" placeholder="Value" style="flex: 1;"
                        [readonly]="user?.role !== Roles.ROLE_DISTRIBUTOR">
                    <button type="button" mat-icon-button (click)="removeMetadataField('update', i)"
                        matTooltip="Remove">
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>
            </div>
        </div>

        <app-insoles-prescription *ngIf="selectedPrescriptionTemplate"
            [insolePrescription]="insolesPrescriptionForm"></app-insoles-prescription>

        <div class="create-button-container">
            <button type="submit" mat-raised-button color="primary"
                [disabled]="updatePrescriptionTemplateForm.invalid">{{ 'UPDATE' |
                translate }}</button>
        </div>
    </form>
</p-dialog>